import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Typography,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import InputMask from "react-input-mask";
import { useState } from "react";
import { validaCpf } from "../../../components/validacoes";
import { Toast } from "../../../services/Swal";
import HelmetThemeColor from "../../../components/HelmetThemeColor/HelmetThemeColor";
const themeColor = "#01a6f0";

const lightTheme = createTheme({
  palette: {
    background: {
      default: "#ffffff",
    },
    primary: {
      main: themeColor,
    },
    secondary: {
      main: "#f34f1c",
    },
  },
});

const box = {
  paddingY: 1,
  display: "flex",
  flexDirection: "column",
  // border: "1px solid black",
};

function ChipDivider({ label, color = "primary" }) {
  return (
    <Grid item xs={12}>
      <Divider>
        <Chip label={label} color={color} />
      </Divider>
    </Grid>
  );
}

export default function CadastroForms() {
  const [form, setForm] = useState({
    consentimento: false,
    nomeCompleto: "",
    cpf: "",
    municipio: "",
    telefone: "",
    whatsApp: "",
    email: "",
    cargoQueOcupa: "",
    tempoEmMeses: 0,
    nomeDaEscola: "",
    estadoDaEscola: "",
    quantosComputadoresRecebeu: 0,
    quantosComputadoresAlocadosAdministrativo: 0,
    quantosComputadoresAlocadosProfessores: 0,
    quantosComputadoresAlocadosAlunos: 0,
    escolaPossuiInternetProfessores: "",
    avaliacaoProjetoCorpoDocente: "",
    justificativaRespostaAvaliacaoCorpoDocente: "",
    computadoresAlunosConectados: "",
    escolaPossuiInternetAlunos: "",
    avaliacaoProjetoAlunos: "",
    justificativaRespostaAvaliacaoAlunos: "",
    comunidadeUsaComputador: "",
    promoveuAtividadeComComputadores: "",
    expliqueAtividadesComComputadores: "",
    precisouManutencaoComComputadores: "",
    quantosAcionamentos: "",
    satisfacaoComEmpresa: 0,
    expectativasComProjeto: "",
    justificativaExpectativasComProjeto: "",
    recomendacoesMelhorImplementacao: "",
    sugestaoPerguntaOuComentario: "",
    dadosPessoais: false,
    // cooperacao: false,
  });

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  function handleCPF(cpf) {
    if (!cpf) return;
    if (!validaCpf(cpf)) {
      setForm({ ...form, cpf: "" });
      Toast.fire({
        icon: "error",
        title: "CPF inválido",
      });
    }
  }

  const header = (
    <>{/* <img src={logo} alt="logo" style={{ maxWidth: "250px" }} /> */}</>
  );

  const inicio = (
    <>
      <ChipDivider label="Início" />

      <Typography component="h1" variant="h5" sx={{ paddingY: 2 }}>
        Pesquisa de Finalização de Projeto - Janelas para o Amanhã
      </Typography>

      <Typography component="h1" variant="body1" sx={{ paddingY: 1 }}>
        Olá, representante da escola participante do projeto Janelas para o
        Amanhã, da Recode em parceria com a Petrobras! Obrigada pela sua
        participação.
      </Typography>

      <Typography component="h1" variant="body1" sx={{ paddingY: 1 }}>
        Este formulário tem como objetivo avaliar como as atividades foram
        implementadas em sua Escola nesses últimos 2 anos.
      </Typography>

      <Typography component="h1" variant="body1" sx={{ paddingY: 1 }}>
        Não haverá riscos e benefícios em sua participação na pesquisa, mas a
        Recode acredita que com suas respostas estaremos redesenhando um projeto
        melhor.
      </Typography>

      <Typography component="h1" variant="body1" sx={{ paddingY: 1 }}>
        As perguntas são, em sua maioria, de múltipla escolha, ou seja, cada
        pergunta só permitirá uma resposta. Além disso, você poderá escolher a
        opção “NQR - Não quero responder”, ou, no caso de perguntas que exijam
        números como respostas, responder 99 para que possamos entender que não
        quer responder.
      </Typography>

      <Typography component="h1" variant="body1" sx={{ paddingY: 1 }}>
        Desde já, agradecemos sua participação e pedimos que responda com a
        máxima sinceridade. Suas respostas serão conhecidas apenas pela Recode
        e, de maneira alguma, iremos repassar as informações para a Petrobras de
        uma forma que possa identificar a sua Escola e/ou a/o respondente. Os
        dados que serão compartilhados com a Petrobras serão em forma de
        relatório contendo dados de todas as Escolas respondentes e de forma
        anonimizada.
      </Typography>
      <Typography component="h1" variant="body1" sx={{ paddingY: 1 }}>
        O tempo estimado para preenchimento deste formulário é de 9 minutos.
      </Typography>
    </>
  );

  const form1 = (
    <Grid container spacing={2}>
      <ChipDivider label="Formulário" />
      <Grid item xs={12}>
        <Typography component="h1" variant="body1" sx={{ paddingY: 1 }}>
          Podemos começar? Se sim, você declara que entendeu o objetivo desta
          pesquisa, bem como sua forma de participação, riscos e benefícios?
        </Typography>

        <FormControl required>
          <FormLabel>
            Por favor, leia atentamente o texto acima antes de prosseguir.
          </FormLabel>
          <RadioGroup
            value={form.consentimento}
            onChange={(e) => {
              setForm({ ...form, consentimento: e.target.checked });
            }}
          >
            <FormControlLabel
              value={true}
              control={<Radio />}
              label="Sim, eu li e compreendi este termo de consentimento. Concordo em participar voluntariamente desta pesquisa e permito que a Recode entre em contato para esclarecer alguma resposta, se necessário."
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          label="Seu nome completo"
          inputProps={{ maxLength: 200 }}
          onChange={(e) => setForm({ ...form, nomeCompleto: e.target.value })}
        />
      </Grid>

      <Grid item xs={12}>
        <InputMask
          mask="999.999.999-99"
          inputProps={{ inputMode: "numeric" }}
          required
          fullWidth
          label="CPF"
          value={form.cpf}
          onBlur={(e) => {
            handleCPF(e.target.value);
          }}
          onChange={(e) => setForm({ ...form, cpf: e.target.value })}
        >
          {(inputProps) => <TextField {...inputProps} />}
        </InputMask>
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          label="Seu município de residência e domicílio"
          onChange={(e) => setForm({ ...form, municipio: e.target.value })}
        />
      </Grid>

      <Grid item xs={12}>
        <InputMask
          mask="(99) 99999-9999"
          maskChar=""
          inputProps={{ inputMode: "numeric" }}
          required
          fullWidth
          label="Seu telefone celular, com DDD"
          value={form.telefone}
          onChange={(e) => setForm({ ...form, telefone: e.target.value })}
          onBlur={() =>
            form.telefone.length < 15
              ? setForm({ ...form, telefone: "" })
              : null
          }
        >
          {(inputProps) => <TextField {...inputProps} />}
        </InputMask>
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Este é o seu número de WhatsApp?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({ ...form, whatsApp: e.target.value });
            }}
            defaultValue=""
            value={form.whatsApp}
          >
            <FormControlLabel
              required
              value="Sim"
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          type="email"
          inputProps={{ maxLength: 50 }}
          label="Seu e-mail"
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Cargo que ocupa na escola
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({ ...form, cargoQueOcupa: e.target.value });
            }}
            defaultValue=""
            value={form.cargoQueOcupa}
          >
            <FormControlLabel
              required
              value="Diretor/a"
              control={<Radio />}
              label="Diretor/a"
            />
            <FormControlLabel
              value="Coordenador/a Pedagógico/a"
              control={<Radio />}
              label="Coordenador/a Pedagógico/a"
            />
            <FormControlLabel
              value="Professor/a"
              control={<Radio />}
              label="Professor/a"
            />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
            <FormControlLabel value="Outro" control={<Radio />} label="Outro" />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          type="number"
          inputProps={{ inputMode: "numeric" }}
          label="Há quanto tempo (em meses) você ocupa este cargo?"
          onChange={(e) => setForm({ ...form, tempoEmMeses: e.target.value })}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          inputProps={{ maxLength: 50 }}
          label="Nome da escola"
          onChange={(e) => setForm({ ...form, nomeDaEscola: e.target.value })}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Estado da escola
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({ ...form, estadoDaEscola: e.target.value });
            }}
            defaultValue=""
            value={form.estadoDaEscola}
          >
            <FormControlLabel
              required
              value="ES (Espírito Santo)"
              control={<Radio />}
              label="ES (Espírito Santo)"
            />
            <FormControlLabel
              value="RJ (Rio de Janeiro)"
              control={<Radio />}
              label="RJ (Rio de Janeiro)"
            />
            <FormControlLabel
              value="SP (São Paulo)"
              control={<Radio />}
              label="SP (São Paulo)"
            />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );

  const form2 = (
    <Grid container spacing={2}>
      <ChipDivider label="Dados do projeto após a doação dos computadores" />

      <Grid item xs={12}>
        <TextField
          fullWidth
          type="number"
          inputProps={{ inputMode: "numeric" }}
          label="Quantos computadores a Escola recebeu do projeto?"
          onChange={(e) =>
            setForm({ ...form, quantosComputadoresRecebeu: e.target.value })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          type="number"
          inputProps={{ inputMode: "numeric" }}
          label="Desse total, quantos foram alocados para uso administrativo da Escola?"
          onChange={(e) =>
            setForm({
              ...form,
              quantosComputadoresAlocadosAdministrativo: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          type="number"
          inputProps={{ inputMode: "numeric" }}
          label="Desse total, quantos foram alocados para uso dos professores?"
          onChange={(e) =>
            setForm({
              ...form,
              quantosComputadoresAlocadosProfessores: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          type="number"
          inputProps={{ inputMode: "numeric" }}
          label="Desse total, quantos foram alocados para uso dos alunos?"
          onChange={(e) =>
            setForm({
              ...form,
              quantosComputadoresAlocadosAlunos: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>
  );

  const form3 = (
    <Grid container spacing={2}>
      <ChipDivider label="Impacto do Projeto nos Professores" />

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Atualmente, a Escola possui banda larga e/ou wi-fi disponível para os
          professores?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                escolaPossuiInternetProfessores: e.target.value,
              });
            }}
            defaultValue=""
            value={form.escolaPossuiInternetProfessores}
          >
            <FormControlLabel
              required
              value="Sim"
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Como avalia a implementação do projeto em sua Escola no que toca à
          contribuição para o corpo docente dos alunos?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                avaliacaoProjetoCorpoDocente: e.target.value,
              });
            }}
            defaultValue=""
            value={form.avaliacaoProjetoCorpoDocente}
          >
            <FormControlLabel
              required
              value="Excelente"
              control={<Radio />}
              label="Excelente"
            />
            <FormControlLabel value="Bom" control={<Radio />} label="Bom" />
            <FormControlLabel
              value="Indiferente"
              control={<Radio />}
              label="Indiferente"
            />
            <FormControlLabel value="Ruim" control={<Radio />} label="Ruim" />
            <FormControlLabel
              value="Péssimo"
              control={<Radio />}
              label="Péssimo"
            />
            <FormControlLabel
              value="Não saberia avaliar"
              control={<Radio />}
              label="Não saberia avaliar"
            />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Poderia justificar sua resposta?"
          onChange={(e) =>
            setForm({
              ...form,
              justificativaRespostaAvaliacaoCorpoDocente: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>
  );

  const form4 = (
    <Grid container spacing={2}>
      <ChipDivider label="Impacto do Projeto nos Alunos" />

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Os computadores alocados para uso dos alunos estão conectados à
          internet?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                computadoresAlunosConectados: e.target.value,
              });
            }}
            defaultValue=""
            value={form.computadoresAlunosConectados}
          >
            <FormControlLabel
              required
              value="Sim, todos"
              control={<Radio />}
              label="Sim, todos"
            />
            <FormControlLabel
              value="Sim, a maioria"
              control={<Radio />}
              label="Sim, a maioria"
            />
            <FormControlLabel
              value="Sim, pequena parte"
              control={<Radio />}
              label="Sim, pequena parte"
            />
            <FormControlLabel
              value="Nenhum deles"
              control={<Radio />}
              label="Nenhum deles"
            />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Atualmente, a Escola possui banda larga e/ou wi-fi disponível para os
          alunos?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                escolaPossuiInternetAlunos: e.target.value,
              });
            }}
            defaultValue=""
            value={form.escolaPossuiInternetAlunos}
          >
            <FormControlLabel
              required
              value="Sim"
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Como avalia a implementação do projeto em sua Escola no que toca à
          contribuição para o ensino e aprendizagem dos alunos?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                avaliacaoProjetoAlunos: e.target.value,
              });
            }}
            defaultValue=""
            value={form.avaliacaoProjetoAlunos}
          >
            <FormControlLabel
              required
              value="Excelente"
              control={<Radio />}
              label="Excelente"
            />
            <FormControlLabel value="Bom" control={<Radio />} label="Bom" />
            <FormControlLabel
              value="Indiferente"
              control={<Radio />}
              label="Indiferente"
            />
            <FormControlLabel value="Ruim" control={<Radio />} label="Ruim" />
            <FormControlLabel
              value="Péssimo"
              control={<Radio />}
              label="Péssimo"
            />
            <FormControlLabel
              value="Não saberia avaliar"
              control={<Radio />}
              label="Não saberia avaliar"
            />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Poderia justificar sua resposta?"
          onChange={(e) =>
            setForm({
              ...form,
              justificativaRespostaAvaliacaoAlunos: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>
  );

  const form5 = (
    <Grid container spacing={2}>
      <ChipDivider label="Impactos do Projeto na Comunidade" />

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Pessoas da comunidade escolar, que não sejam alunos e/ou funcionários
          da Escola, podem usar os computadores doados pela Petrobras?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                comunidadeUsaComputador: e.target.value,
              });
            }}
            defaultValue=""
            value={form.comunidadeUsaComputador}
          >
            <FormControlLabel
              required
              value="Sim"
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          A escola promoveu alguma atividade aberta para a comunidade escolar
          utilizando os computadores doados pelo projeto?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                promoveuAtividadeComComputadores: e.target.value,
              });
            }}
            defaultValue=""
            value={form.promoveuAtividadeComComputadores}
          >
            <FormControlLabel
              required
              value="Sim"
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <TextField
        fullWidth
        label="Se sim, poderia explicar quais atividades para comunidade foram implementadas?"
        onChange={(e) =>
          setForm({
            ...form,
            expliqueAtividadesComComputadores: e.target.value,
          })
        }
      />
    </Grid>
  );

  const form6 = (
    <Grid container spacing={2}>
      <ChipDivider label="Avaliação de suporte aos computadores" />
      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Ao longo do projeto, a Escola precisou acionar a empresa que prestava
          serviços sobre instalação e/ou manutenção elétrica e manutenção dos
          equipamentos doados?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                precisouManutencaoComComputadores: e.target.value,
              });
            }}
            defaultValue=""
            value={form.precisouManutencaoComComputadores}
          >
            <FormControlLabel
              required
              value="Sim"
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
            <FormControlLabel
              value="Não sabíamos da existência deste serviço"
              control={<Radio />}
              label="Não sabíamos da existência deste serviço"
            />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Quantas vezes a escola acionou a empresa?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                quantosAcionamentos: e.target.value,
              });
            }}
            defaultValue=""
            value={form.quantosAcionamentos}
          >
            <FormControlLabel
              required
              value="Nunca acionamos a empresa"
              control={<Radio />}
              label="Nunca acionamos a empresa"
            />
            <FormControlLabel
              value="Uma única vez"
              control={<Radio />}
              label="Uma única vez"
            />
            <FormControlLabel
              value="2-3 vezes"
              control={<Radio />}
              label="2-3 vezes"
            />
            <FormControlLabel
              value="4-5 vezes"
              control={<Radio />}
              label="4-5 vezes"
            />
            <FormControlLabel
              value="6 vezes ou mais"
              control={<Radio />}
              label="6 vezes ou mais"
            />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Caso tenha acionado a empresa, qual foi o seu nível de satisfação,
          dentro de uma escala de 1 a 10, sendo 1 muito insatisfeito e 10, muito
          satisfeito, com os serviços prestados?
        </Typography>

        <Slider
          defaultValue={5}
          onChange={(e) => {
            setForm({
              ...form,
              satisfacaoComEmpresa: e.target.value,
            });
          }}
          valueLabelDisplay="auto"
          step={1}
          marks={[
            {
              value: 1,
              label: "1",
            },
            {
              value: 2,
              label: "2",
            },

            {
              value: 3,
              label: "3",
            },
            {
              value: 4,
              label: "4",
            },
            {
              value: 5,
              label: "5",
            },
            {
              value: 6,
              label: "6",
            },
            {
              value: 7,
              label: "7",
            },
            {
              value: 8,
              label: "8",
            },
            {
              value: 9,
              label: "9",
            },
            {
              value: 10,
              label: "10",
            },
          ]}
          min={1}
          max={10}
        />
      </Grid>
    </Grid>
  );

  const form7 = (
    <Grid container spacing={2}>
      <ChipDivider label="Conclusão" />

      <Grid item xs={12}>
        <Typography component="h1" variant="body1">
          Suas expectativas em relação ao Projeto Janelas para o Amanhã foram
          alcançadas?
        </Typography>

        <FormControl required>
          <RadioGroup
            onChange={(e) => {
              setForm({
                ...form,
                expectativasComProjeto: e.target.value,
              });
            }}
            defaultValue=""
            value={form.expectativasComProjeto}
          >
            <FormControlLabel
              required
              value="Sim"
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel value="Não" control={<Radio />} label="Não" />
            <FormControlLabel
              value="NQR (Não Quero Responder)"
              control={<Radio />}
              label="NQR (Não Quero Responder)"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Por favor, justifique sua resposta."
          onChange={(e) =>
            setForm({
              ...form,
              justificativaExpectativasComProjeto: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          multiline
          minRows={3}
          fullWidth
          label="Quais seriam suas recomendações para que a Recode implementasse melhor o projeto Janelas para o Amanhã?"
          onChange={(e) =>
            setForm({
              ...form,
              recomendacoesMelhorImplementacao: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          multiline
          minRows={3}
          fullWidth
          label="Quer fazer alguma sugestão, pergunta ou comentário sobre os temas tratados ao longo da pesquisa?"
          onChange={(e) =>
            setForm({
              ...form,
              sugestaoPerguntaOuComentario: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <Typography component="h1" variant="body1" sx={{ paddingY: 1 }}>
          Estou de acordo com o Termo de Consentimento para Tratamento de Dados
          <br />
          Pessoais, disponível 
          <a
            target="_blank"
            href="/TermoConsentimentoTratamentoDadosPessoais_Endline-Escolas_2023_10_19.pdf"
          >
            {" "}aqui
          </a>
        </Typography>

        <FormControl required>
          <RadioGroup
            defaultValue={false}
            value={form.dadosPessoais}
            onChange={(e) => {
              setForm({ ...form, dadosPessoais: e.target.checked });
            }}
          >
            <FormControlLabel
              required
              value={true}
              control={<Radio />}
              label="Sim, estou de acordo"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );

  const regua = (
    <></>
    // <Box
    //   xs={12}
    //   sx={{
    //     paddingTop: 8,
    //     display: "flex",
    //     flexDirection: "column",
    //     alignItems: "center",
    //   }}
    // >
    //   <img src={regua} alt="régua de logos" style={{ maxWidth: "100%" }} />
    // </Box>
  );

  const redirect = () => window.location.replace("https://recode.org.br");

  const dialog = (
    <>
      <Dialog open={open} keepMounted onClose={redirect}>
        <DialogTitle>Sucesso!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Obrigado por responder ao formulário
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={redirect}>Concluir</Button>
        </DialogActions>
      </Dialog>
    </>
  );

  const handleForm = (e) => {
    e.preventDefault();
    setLoading(true);

    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    };

    fetch(`${process.env.REACT_APP_BACKEND}/api/Forms/FormJanelas`, request)
      .then((response) => response.json())
      .then((data) => {
        console.warn(data);
        if (data.success) {
          setOpen(true);
        } else {
          Toast.fire({
            icon: "error",
            title: data.message,
          });
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <HelmetThemeColor color={themeColor} />
      <Container maxWidth="md" sx={{ paddingY: 3 }}>
        <form
          onSubmit={handleForm}
          // onSubmit={(e) => {
          //   e.preventDefault();
          //   console.log(form);
          // }}
          autoComplete="off"
          // noValidate
        >
          <Box
            sx={{
              ...box,
              alignItems: "center",
            }}
          >
            {header}
          </Box>

          <Box sx={box}>{inicio}</Box>

          <Box sx={box}>{form1}</Box>
          <Box sx={box}>{form2}</Box>
          <Box sx={box}>{form3}</Box>
          <Box sx={box}>{form4}</Box>
          <Box sx={box}>{form5}</Box>
          <Box sx={box}>{form6}</Box>
          <Box sx={box}>{form7}</Box>

          <Box sx={box}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, p: 1 }}
              disabled={loading}
            >
              {!loading ? (
                "Enviar"
              ) : (
                <CircularProgress color="secondary" size={22} />
              )}
            </Button>
          </Box>

          {regua}
        </form>
        {dialog}
      </Container>
    </ThemeProvider>
  );
}
